<template>
  <div
    v-title="title"
    class="badge badge-pill pill-md mr-1"
    :class="[`badge-${colorType}`]"
  >
    <i
      v-if="icon"
      class="fa"
      :class="[`fa-${icon}`, text ? 'mr-1': '']"
    ></i>

    <span v-if="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    colorType: {
      type: String,
      default() {
        return 'cr-red';
      },
    },
    icon: {
      type: String,
    },
    text: {
      type: String,
    },
    title: {
      type: String,
    },
  },
};
</script>
